var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('top-banner',{attrs:{"title":"Our Company","subtitle":"Enhance and grow your career by applying to work with STS's experienced experts","topimage":_vm.image}}),_c('navbar'),_c('read'),_c('our-team')],1)}
var staticRenderFns = []

export { render, staticRenderFns }